import Alert from 'antd/es/alert';
import Button from 'antd/es/button';
import Divider from 'antd/es/divider';
import Form from 'antd/es/form';
import Typography from 'antd/es/typography';
import { styled } from 'styled-components';

export const LoginOptionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
`;

export const PasswordSection = styled.div`
  ${({ theme }) => `
  display: flex;
  flex-direction: column;
  gap: ${theme.margin}px;
  margin-bottom: ${theme.margin}px;
`}
`;

export const MagicLinkSection = styled.div`
  ${({ theme }) => `
  display: flex;
  flex-direction: column;
  gap: ${theme.margin}px;
  text-align: center;
`}
`;

export const LoginMethodContainer = styled.div`
  ${({ theme }) => `
  display: flex;
  flex-direction: column;
  text-align: center;
  margin: 0 auto;

  .ant-form-item-label {
    padding-bottom: ${theme.paddingXXS}px;
  }

  .ant-form-item {
    margin-bottom: ${theme.margin}px;
  }

  .ant-form-item:has(.ant-input:not(.ant-input-password)) {
    width: 100%;
    height: 100%;

    .ant-input {
      width: 100%;
      min-width: ${theme.screenXSMax - 175}px;
    }
  }

  a {
    color: ${theme.colorPrimary};
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }

  h1.ant-typography {
    font-weight: ${theme.fontWeightStrong / 6} !important;
  }

  h2.ant-typography {
    font-weight: ${theme.fontWeightStrong / 1.5} !important;
  }

  h3.ant-typography {
    font-weight: ${theme.fontWeightStrong} !important;
    font-size: ${theme.fontSizeHeading4}px !important;
  }
`}
`;

export const ChangeLink = styled.button`
  ${({ theme }) => `
  background: none;
  border: none;
  color: ${theme.colorPrimary};
  cursor: pointer;
  text-decoration: underline;
  padding: 0;
  font: inherit;

  &:hover {
    text-decoration: none;
  } 
`}
`;

export const SubText = styled(Typography.Text)`
  ${({ theme }) => `
  color: ${theme.colorTextSecondary};
  margin-bottom: ${theme.margin}px;
`}
`;

export const CardContainer = styled.div`
  ${({ theme }) => `
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${theme.padding}px;
`}
`;

export const LoginTitle = styled(Typography.Title)`
  ${({ theme }) => `
  margin-bottom: ${theme.marginLG}px !important;
`}
`;

export const LoginTitleCompact = styled(Typography.Title)`
  ${({ theme }) => `
  margin-bottom: ${theme.marginXXS}px !important;
`}
`;

export const StyledAlert = styled(Alert)`
  ${({ theme }) => `
  margin-bottom: ${theme.marginLG}px;
`}
`;

export const StyledAlertCompact = styled(Alert)`
  ${({ theme }) => `
  margin-bottom: ${theme.margin}px;
`}
`;

export const StyledDivider = styled(Divider)`
  ${({ theme }) => `
  margin: ${theme.marginLG}px 0;
`}
`;

export const FullWidthButton = styled(Button)`
  width: 100%;
`;

export const BottomText = styled(Typography.Text)`
  ${({ theme }) => `
  margin-bottom: ${theme.margin}px;
`}
`;

export const FormItemLeft = styled(Form.Item)`
  text-align: left;
`;

export const FormItemWithMargin = styled(Form.Item)`
  ${({ theme }) => `
  margin-bottom: ${theme.margin}px !important;
`}
  text-align: left;
`;

export const RememberMeSection = styled.div`
  ${({ theme }) => `
  display: flex;
  gap: ${theme.margin}px;
  flex-direction: column;
  align-items: flex-start;
`}
`;
